// Path: packages/core/src/services/profileApi.js
import authService from './authService';
import config from '../config';
const API_BASE_URL = config.API_BASE_URL;
const USER_PROFILE_API_PREFIX = '/api/v1/profiles/user';

export const getMyUserProfile = async () => {
  const url = `${API_BASE_URL}${USER_PROFILE_API_PREFIX}/me`;
  try {
    const response = await authService.authFetch(url);
    if (response.status === 404) {
        console.log(`[profileApi] User profile not found (404). Returning null.`);
        return null;
    }
    if (!response.ok) {
      let errorDetail = `Failed to fetch user profile: ${response.status}`;
      try {
        const errorData = await response.json();
        errorDetail = errorData.detail || errorDetail;
      } catch (e) {  }
      throw new Error(errorDetail);
    }
    const profile = await response.json();
    return profile;
  } catch (error) {
    console.error('[profileApi] Error fetching user profile:', error);
    if (!error.message?.includes('404')) {
        // REMOVED: authService.trackNetworkError('getMyUserProfile', error);
        throw error;
    }
    return null;
  }
};

export const updateMyUserProfile = async (profileData) => {
  const url = `${API_BASE_URL}${USER_PROFILE_API_PREFIX}/me`;
  try {
    const response = await authService.authFetch(url, {
      method: 'PUT',
      body: profileData,
    });
    if (!response.ok) {
      let errorDetail = `Failed to update user profile: ${response.status}`;
      try {
        const errorData = await response.json();
        errorDetail = errorData.detail || errorDetail;
      } catch (e) {  }
      throw new Error(errorDetail);
    }
    const updatedProfile = await response.json();
    return updatedProfile;
  } catch (error) {
    console.error('[profileApi] Error updating user profile:', error);
    // REMOVED: authService.trackNetworkError('updateMyUserProfile', error);
    throw error;
  }
};

export const adminUpdateUserCoreDetails = async (userId, updateData) => {
  const url = `${API_BASE_URL}${USER_PROFILE_API_PREFIX}/${userId}`;
  try {
    const response = await authService.authFetch(url, {
      method: 'PUT',
      body: updateData,
    });
    if (!response.ok) {
      let errorDetail = `Failed to update user details (Admin): ${response.status}`;
      try {
        const errorData = await response.json();
        errorDetail = errorData.detail || errorDetail;
      } catch (e) {  }
      if (response.status === 403) {
           errorDetail = "Permission Denied: Administrator privileges required.";
      }
      throw new Error(errorDetail);
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error(`[profileApi] Error updating user ${userId} core details (Admin):`, error);
    // REMOVED: authService.trackNetworkError('adminUpdateUserCoreDetails', error);
    throw error;
  }
};

export default {
  getMyUserProfile,
  updateMyUserProfile,
  adminUpdateUserCoreDetails,
};